'use memo';
import { createFileRoute } from '@tanstack/react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { IssueAddPage } from './-components/IssueAddPage';

/**
 * 不具合 新規追加画面 (route 登録)。
 *
 * 本体実装は `-components/IssueAddPage.tsx` に分離 (playbook §3.18:
 * react-hook-form を含む可能性が高い画面は route 直下 inline 不可)。
 * route ファイル側では useDocumentTitle のみ呼び出し、describe / render は
 * 分離先に委ねる。
 */
export const Route = createFileRoute('/_stacktrace/issues/add/')({
  component: IssueAddRouteComponent,
});

function IssueAddRouteComponent() {
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'issues.add',
  });
  useDocumentTitle(t('pageTitle'));
  return <IssueAddPage />;
}
